/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>交易订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.userkey" placeholder="输入姓名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.transId" placeholder="输入交易单号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.payStatus" placeholder="请选择支付状态">
          <el-option v-for="type in payStatus" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.payType" placeholder="请选择订单类型">
          <el-option v-for="type in payType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
          <el-date-picker
            v-model="formInline.date"
            value-format="timestamp"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-refresh-left" @click="formReset()">重置</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column align="center" prop="patient_realname" label="姓名" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="treatmentcard_no" label="健康卡号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="weixin_transaction_id" label="交易单号" width="210" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="hospital_transaction_id" align="center" label="his发票号1" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="actual_fee_total" align="center" label="支付金额" width="80" show-overflow-tooltip>
      </el-table-column>

      <el-table-column sortable prop="trade_end_time" label="支付时间" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="trade_state" align="center" label="订单状态" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-show="scope.row.trade_state == 'SUCCESS'"><span style="color: blue;">缴费成功</span></div>
          <div v-show="scope.row.trade_state == 'SUCCESSBUTHISERROR'"><span style="color: red;">单边账</span></div>
          <div v-show="scope.row.trade_state == 'REFUND'"><span style="color: gray;">已退费</span></div>
        </template>
      </el-table-column>
      <el-table-column prop="trade_type" align="center" label="订单类型" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" width="160">
        <template slot-scope="scope">
          <div v-if="scope.row.trade_state == 'SUCCESSBUTHISERROR'">
            <el-button size="mini" type="danger" @click="refund(scope.row)">退款</el-button>
            <el-button size="mini" type="success" @click="autoOrder(scope.row)">同步</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :visible.sync="refundVisible" width="300px">
      <el-form>
        <el-form-item label="退费密码">
          <el-input type="password" v-model="refund_passwd" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="refundVisible = false">取 消</el-button>
        <el-button type="primary" @click="toRefund()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { OrderList, orderToHis,wxRefund } from '../../api/payMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false,
      refundVisible: false,
      refund_passwd: '',
      refund_row: [],
      payStatus: [
        { key: '请选择', value: 0 },
        { key: '缴费成功', value: 'SUCCESS' },
        { key: '单边账', value: 'SUCCESSBUTHISERROR' },
        { key: '已退费', value: 'REFUND' }
      ],
      payType: [
        { key: '请选择', value: 0 },
        { key: '门诊挂号', value: '门诊挂号' },
        { key: '门诊缴费', value: '门诊缴费' },
        { key: '住院预交金', value: '住院预交金' }
      ],
      formInline: {
        page: 1,
        limit: 10
      },
      listData: [], //订单数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
        OrderList(parameter)
         .then(res => {
           this.loading = false
           if (res.success == false) {
             this.$message({
               type: 'info',
               message: res.msg
             })
           } else {
             this.listData = res.data
             // 分页赋值
             this.pageparm.currentPage = this.formInline.page
             this.pageparm.pageSize = this.formInline.limit
             this.pageparm.total = res.count
           }
         })
         .catch(err => {
           this.loading = false
           this.$message.error('数据加载失败，请稍后再试！')
         })
    },
    // 重置搜索
    formReset() {
       this.formInline = {
        page: 1,
        limit: 10
      }
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.page = 1
      this.formInline.limit = 10
      this.getdata(this.formInline)
    },
    // 退费
    refund(row) {
      this.refund_row = row;
      this.refundVisible = true;
    },
    toRefund() {
      if(this.refund_passwd === '') {
        this.$message.error('退费密码不能为空！')
        return;
      }
      this.refundVisible = false;
      this.loading = true
      const row = this.refund_row
      const data = {payinfo:row.weixin_transaction_id,fee:row.actual_fee_total,status:row.trade_state,refpasswd:this.refund_passwd}
      wxRefund(data).then(res => {
        this.loading = false
        if(res.code == 0){
          this.getdata(this.formInline)
          this.$message({
            type: 'success',
            message: res.msg
          })
        }else{
          this.$message.error(res.msg)
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('退费失败，请稍后再试！')
      })
    },
    autoOrder(row) {
      this.$confirm('确定要同步订单信息吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        this.loading = true
        const param = {id:row.id}
        orderToHis(param)
          .then(res => {
            this.loading = false
            this.$message({
              type: 'info',
              message: res.msg
            })
          })
          .catch(err => {
            this.loading = false
            this.$message.error('同步失败，请稍后再试！')
          })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消同步'
        })
      })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/pay/Order.vue